import { GlobalHeader } from './common/_GlobalHeader.js';
import { GlobalFooter } from './common/_GlobalFooter.js';
import { Fadein } from './common/_Modules.js';
import { Intro } from './common/_Modules.js';
import Home from './page/_Home.js';
import Company from './page/_Company.js';

// import { ScrollEvent }  from "./common/_modules.js";

class common {

	constructor () {
		this.view = window;
        this.view.addEventListener('resize', () => { this.resize(); });
		this.modules = {};
		this.media();

        this.view.addEventListener('pageshow', () => {
			// console.log('pageshow');
			this.init();
		});
		// iOS 100vh対応
		document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);

		// if(navigator.userAgent.toLocaleLowerCase().indexOf('safari') != 0) {
		// }
		const userAgent = navigator.userAgent.toLocaleLowerCase();

        if (userAgent.includes('msie') || userAgent.includes('trident')) {
            document.documentElement.classList.add('browser-ie');
        } else if (userAgent.includes('edge')) {
            document.documentElement.classList.add('browser-edge');
        } else if (userAgent.includes('chrome')) {
            document.documentElement.classList.add('browser-chrome');
        } else if (userAgent.includes('safari')) {
            document.documentElement.classList.add('browser-safari');
        } else if (userAgent.includes('firefox')) {
            document.documentElement.classList.add('browser-firefox');
        } else if (userAgent.includes('opera')) {
            document.documentElement.classList.add('browser-opera');
        }
	}

	init () {
		this.modules.scrollmagic = new ScrollMagic.Controller();
		this.global_header = new GlobalHeader(this);
		this.global_footer = new GlobalFooter(this);
		this.modules = {};
		this.page = {};
		this.modules.fadein = new Fadein(this);
		this.modules.intro = new Intro(this);
		this.page.home = new Home(this);
		this.page.company = new Company(this);
	}

	media (device) {
		this.media.device = window.matchMedia('(max-width: 1000px)').matches ? 'SP' : 'PC';

		if (this.media.device == device) {
			return true;
		} else {
			return false;
		}
	}

	resize () {
		// レスポンシブイベント発火
		if(!this.media(this.media.device)) {
			if(this.media('SP')) {
                const resizeResponsiveEvent = new Event('resize:responsive');
                const resizeResponsiveSPEvent = new Event('resize:responsive:SP');
                window.dispatchEvent(resizeResponsiveEvent);
                window.dispatchEvent(resizeResponsiveSPEvent);

			} else {
                const resizeResponsiveEvent = new Event('resize:responsive');
                const resizeResponsivePCEvent = new Event('resize:responsive:PC');
                window.dispatchEvent(resizeResponsiveEvent);
                window.dispatchEvent(resizeResponsivePCEvent);
			}
		}
	}
}

window.common = new common();
